import type { TuFunction } from "@src/appV2/i18n/types";

import { type InviteWarningReason } from "./types";

export function getWarningContent(
  warning: InviteWarningReason,
  tu: TuFunction
): { title: string; message: string } {
  switch (warning.type) {
    case "SHIFT_OVERWORKING": {
      return {
        title: tu("Potential overwork"),
        message: tu("This shift may lead to work exceeding the recommended 17-hour limit."),
      };
    }
    case "SHIFT_OVERWORKING_FROM_INVITES": {
      return {
        title: tu("Potential overwork from invites"),
        message: tu(
          "If all pending invites are accepted, this shift may lead to work exceeding the recommended 17-hour limit."
        ),
      };
    }
    case "SHIFT_OVERLAPPING": {
      return {
        title: tu("Overlapping shift"),
        message: tu("This worker already has a booked shift that overlaps with this time slot."),
      };
    }
    case "HIGH_CALLOFF_RATE": {
      return {
        title: tu("High call-off rate"),
        message: tu("This professional has a call-off rate of {{calloffRate}}%.", {
          values: { calloffRate: warning.details.calloffRate },
        }),
      };
    }
    case "MISSING_BACKGROUND_CHECK_DATA": {
      return {
        title: tu("Missing background check data"),
        message: tu("This professional is missing background check data."),
      };
    }
    case "MISSING_FACILITY_REQUIRED_DOCS": {
      const documentList = warning.details.missingDocuments.join(", ");
      return {
        title: tu("Worker is missing workplace requirements"),
        message: tu(
          "Missing documents: {{documentList}}. You can still send the invite, but the worker may be unable to clock in until those documents are uploaded.",
          {
            values: { documentList },
          }
        ),
      };
    }
  }
}
